import styled from 'styled-components/macro';

export const Wrapper = styled.div<{
  backgroundColor: string;
  borderColor?: string;
  width?: string;
  height?: string;
}>`
  display: inline-flex;
  height: ${({ theme, height }) => height || theme.spacing.one_3};
  width: ${({ width }) => width};
  padding: ${({ theme }) => theme.spacing.zero} ${({ theme }) => theme.spacing.zero_2};
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  gap: ${({ theme }) => theme.spacing.zero};
  border-radius: 16px;
  border: ${({ borderColor }) => (borderColor ? `1px solid ${borderColor}` : 'none')};
  background-color: ${({ backgroundColor }) => backgroundColor};
`;

export const Label = styled.p<{ color: string; fontFamily?: string; fontSize?: string }>`
  color: ${({ color }) => color};
  font-family: ${({ fontFamily, theme }) => fontFamily || theme.fontFamily.regular};
  font-size: ${({ fontSize, theme }) => fontSize || theme.fontSize.sm};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  letter-spacing: ${({ theme }) => theme.letterSpacing.sm};
`;
